import { useAcoordReducedMotion } from '../../hooks/useAcoordReducedMotion';

export const useInvestorReducedMotion = () => useAcoordReducedMotion();